export default "__VITE_ASSET__yqNqOLPh__"